import React from "react"
import CustomButton, { CustomButtonProps } from "../Atoms/CustomButton"

const RemoveButton = ({ onClick, ...otherProps }: CustomButtonProps) => {
  return (
    <CustomButton
      intent="danger"
      onClick={onClick}
      icon="minus"
      small={true}
      minimal={true}
      round={true}
      {...otherProps}
    />
  )
}

export default RemoveButton
